var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":_vm.$trans('v2.i2m_components.name')},on:{"input":_vm.emitInput},model:{value:(_vm.bindValue),callback:function ($$v) {_vm.bindValue=$$v},expression:"bindValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }